export default {
  root: {
    minWidth: '40px',
  },
};
